// React
import { useCallback } from 'react';

// Models
import { useStores } from 'models';

// Interfaces
import {
  IAssessmentPreparationCommentGetListAttrs,
  IAssessmentPreparationCommentUpdateAttrs,
  IAssessmentPreparationCommentUpdateManyAttrs,
} from 'interfaces/back-office/assessment/preparation/comment/comment-view.interface';

const useAssessmentPreparationComment = () => {
  // Hook
  const {
    assessmentPreparationComment: {
      assessmentPreparationComment_loading,
      assessmentPreparationComment_list,
      assessmentPreparationComment_CLEAR_LIST,
      assessmentPreparationComment_fetchList: fetchList,
      assessmentPreparationComment_update: update,
      assessmentPreparationComment_updateMany: updateMany,
    },
  } = useStores();

  /**
   * @description Fetch assessment preparation comment list
   *
   * @param {IAssessmentPreparationCommentGetListAttrs} payload
   *
   * @return {Promise<void>} Promise<void>
   */
  const assessmentPreparationComment_fetchList = useCallback(
    (payload: IAssessmentPreparationCommentGetListAttrs): Promise<void> => {
      return new Promise((resolve, reject) => {
        fetchList({
          params: { ...payload.params },
          requestConfig: { ...payload.requestConfig },
          onSuccess: resolve,
          onError: reject,
        });
      });
    },
    [fetchList],
  );

  /**
   * @description Update assessment preparation comment
   *
   * @param {IAssessmentPreparationCommentUpdateAttrs} payload
   *
   * @return {Promise<void>} Promise<void>
   */
  const assessmentPreparationComment_update = useCallback(
    (payload: IAssessmentPreparationCommentUpdateAttrs): Promise<void> => {
      return new Promise((resolve, reject) => {
        update({
          params: { ...payload.params },
          body: { ...payload.body },
          requestConfig: { ...payload.requestConfig },
          onSuccess: resolve,
          onError: reject,
        });
      });
    },
    [update],
  );

  /**
   * @description Update many assessment preparation comment
   *
   * @param {IAssessmentPreparationCommentUpdateManyAttrs} payload
   *
   * @return {Promise<void>} Promise<void>
   */
  const assessmentPreparationComment_update_many = useCallback(
    (payload: IAssessmentPreparationCommentUpdateManyAttrs): Promise<void> => {
      return new Promise((resolve, reject) => {
        updateMany({
          body: { ...payload.body },
          requestConfig: { ...payload.requestConfig },
          onSuccess: resolve,
          onError: reject,
        });
      });
    },
    [updateMany],
  );

  return {
    assessmentPreparationComment_loading,
    assessmentPreparationComment_list,
    assessmentPreparationComment_CLEAR_LIST,
    assessmentPreparationComment_fetchList,
    assessmentPreparationComment_update,
    assessmentPreparationComment_update_many,
  };
};

export { useAssessmentPreparationComment };
